import styled from 'styled-components';

export default styled.span`
  cursor: pointer;
  color: #4266ff;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
`;
